import React from "react";
import dynamicfunction from "../utils/dynamicfunction";
import { cn } from "../utils/utils";

const ViewReverse = ({ children, className, style, onClick, isReverse=true }) => {
  const { isArabic } = dynamicfunction();

  return (
    <div
      className={cn('flex', (isArabic && isReverse) ? "flex-row-reverse" : "flex-row", className)}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default ViewReverse;
